import { Injectable } from '@angular/core';
import { AbstractControl, ValidationErrors } from '@angular/forms';

export const EXPIRY_DATE_PATTERN: RegExp = /^(\d{2})\/(\d{2})$/;

@Injectable({
  providedIn: 'root'
})
export class ExpiryDateValidatorUtils {
  static expiryDateValidator(control: AbstractControl): ValidationErrors | null {
    const expiry_date: string = control.value;
    if (!expiry_date) return null;

    const parts: RegExpMatchArray | null = `${expiry_date}`.match(EXPIRY_DATE_PATTERN);
    if (!parts) return { expired_date: true };

    const month: number = parseInt(parts[1], 10);
    const parsed_year: number = parseInt(parts[2], 10);
    const year: number = parsed_year < 100 ? 2000 + parsed_year : parsed_year;

    if (month < 1 || month > 12) return { expired_date: true };

    const today: Date = new Date();
    const current_year: number = today.getFullYear();
    const current_month: number = today.getMonth() + 1;

    if (year < current_year || (year === current_year && month <= current_month))
      return { expired_date: true };

    return null;
  }
}
